/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileIdeaResponse } from '../../models/profile-idea-response';

export interface ListProfileIdeas$Params {
}

export function listProfileIdeas(http: HttpClient, rootUrl: string, params?: ListProfileIdeas$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileIdeaResponse>>> {
  const rb = new RequestBuilder(rootUrl, listProfileIdeas.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProfileIdeaResponse>>;
    })
  );
}

listProfileIdeas.PATH = '/rest/user/profile-idea';
